function failbackLocalStorage() {
  const data = {};
  return {
    getItem(name) {
      return data[name];
    },
    setItem(name, value) {
      data[name] = value;
    },
  };
}

const localStorage = (function (window) {
  try {
    return window.localStorage || failbackLocalStorage();
  } catch (ex) {
    return failbackLocalStorage();
  }
})(window);

export default localStorage;
